/* eslint-disable no-console */

export const VOICE_LANGS = [
  { id: "pt-BR", label: "Português (BR)" },
  { id: "en-US", label: "English (US)" },
  { id: "es-ES", label: "Español (ES)" },
];

function getSpeechRecognitionCtor() {
  const w = window;
  return w.SpeechRecognition || w.webkitSpeechRecognition || null;
}

export function isSTTSupported() {
  return Boolean(getSpeechRecognitionCtor());
}

export function isTTSSupported() {
  return typeof window !== "undefined" && "speechSynthesis" in window && "SpeechSynthesisUtterance" in window;
}

export function createRecognizer({ lang, onText, onError, onEnd }) {
  const Ctor = getSpeechRecognitionCtor();
  if (!Ctor) return null;

  const rec = new Ctor();
  rec.lang = lang || "pt-BR";
  rec.interimResults = true;
  rec.continuous = false;

  rec.onresult = (event) => {
    try {
      let finalText = "";
      let interimText = "";

      for (let i = event.resultIndex; i < event.results.length; i += 1) {
        const res = event.results[i];
        const transcript = (res[0] && res[0].transcript) ? res[0].transcript : "";
        if (res.isFinal) finalText += transcript;
        else interimText += transcript;
      }

      const text = (finalText || interimText || "").trim();
      if (text && typeof onText === "function") onText(text, Boolean(finalText));
    } catch (e) {
      if (typeof onError === "function") onError(e);
    }
  };

  rec.onerror = (e) => {
    if (typeof onError === "function") onError(e);
  };

  rec.onend = () => {
    if (typeof onEnd === "function") onEnd();
  };

  return rec;
}

export function speakText(text, { lang = "pt-BR", rate = 1, pitch = 1, volume = 1 } = {}) {
  if (!isTTSSupported()) return false;
  const clean = String(text || "").trim();
  if (!clean) return false;

  try {
    window.speechSynthesis.cancel(); // conservador: evita fila infinita

    const u = new SpeechSynthesisUtterance(clean);
    u.lang = lang;
    u.rate = rate;
    u.pitch = pitch;
    u.volume = volume;

    window.speechSynthesis.speak(u);
    return true;
  } catch (e) {
    console.warn("[TTS] falhou:", e);
    return false;
  }
}

export function stopSpeak() {
  if (!isTTSSupported()) return;
  try {
    window.speechSynthesis.cancel();
  } catch {}
}
